<template>
  <el-dialog
    class="dialogManageDebt"
    :visible="true"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    @close="$emit('close')"
    width="570px">
    <div
      slot="title"
      class="mb-2 font-16 fw-700 text-center">
      Quản lý giao dịch
    </div>
    <div>
      <div
        class="z2-conversation-header border-bottom"
        style="width: 320px">
        <div
          class="radio-button"
          :class="tab === 'create' && 'radio-button-active'"
          @click="tab = 'create'">
          <span>Tạo khoản thu mới</span>
        </div>
        <div
          class="radio-button"
          :class="tab === 'history' && 'radio-button-active'"
          @click="tab = 'history'">
          <span>Lịch sử giao dịch</span>
        </div>
      </div>
      <div
        v-if="tab === 'create'"
        style="min-height: 400px; max-height: 400px; overflow-y: auto">
        <div
          v-if="merchantList.length"
          class="flex-column mx-12 px-12 py-12 rounded-2"
          style="border: 1px solid #eaecf2">
          <div>
            <el-dropdown
              size="small"
              trigger="click">
              <div
                class="d-flex align-items-center flex-grow-1 merchant-container"
                style="width: 520px">
                <img
                  v-if="selectedMerchant?.bankCode == 'BIDV'"
                  src="/assets/images/logo-BIDV.svg" />
                <div class="d-flex flex-column flex-grow-1 px-12">
                  <span class="font-14 fw-700 text-blue500">{{ selectedMerchant.accountNo }}</span>
                  <span class="font-13 text-grey700">{{ selectedMerchant.accountName }}</span>
                </div>
                <IconV2
                  name="v2-arrow1_drop_down"
                  size="20px" />
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="item in merchantList"
                  :key="item.id"
                  class="px-0">
                  <div
                    class="d-flex align-items-center flex-grow-1 merchant-container py-2"
                    style="width: 365px"
                    @click="selectedMerchant = item">
                    <img
                      v-if="item.bankCode == 'BIDV'"
                      src="/assets/images/logo-BIDV.svg" />
                    <div class="d-flex flex-column px-12">
                      <span class="font-14 fw-700 text-blue500">{{ item.accountNo }}</span>
                      <span class="font-13 text-grey700">{{ item.accountName }}</span>
                    </div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-divider class="my-2" />
          <div class="d-flex">
            <div>
              <div class="mb-1 mt-2">
                Số tiền
                <span class="text-red500">*</span>
              </div>
              <el-input
                type="number"
                size="small"
                placeholder="Nhập số tiền"
                v-model="debt.amount">
                <span slot="append">VND</span>
              </el-input>
            </div>
            <div class="flex-grow-1 ms-2">
              <div class="mb-1 mt-2">Mã khoản thu</div>
              <el-input
                size="small"
                placeholder="Mã sẽ được tạo tự động nếu bỏ trống"
                v-model="debt.billRef" />
            </div>
          </div>

          <div>
            <div class="mb-1 mt-2">Tên khách hàng</div>
            <el-input
              size="small"
              clearable
              placeholder="Nhập tên khách hàng mua hàng"
              v-model="debt.payer" />
          </div>
          <div>
            <div class="mb-1 mt-2">Ghi chú</div>
            <el-input
              type="textarea"
              resize="none"
              :rows="3"
              placeholder="Nhập mã hoá đơn, thông tin cần lưu ý về khoản thu..."
              v-model="debt.note" />
          </div>

          <div class="d-flex mt-3 justify-content-end">
            <el-button
              type="info"
              @click="$emit('close')">
              Hủy
            </el-button>
            <el-button
              type="primary"
              @click="createNewDebt()">
              Tạo mã
            </el-button>
          </div>
        </div>

        <div
          v-else
          class="d-flex flex-column flex-grow-1 align-items-center jusitfy-content-between px-4"
          style="height: 320px">
          <img src="/assets/images/empty-merchant.svg" />
          <div
            class="text-grey600 font-16 text-center"
            style="height: 150px; white-space: pre">
            {{
              `Quý khách chưa liên kết tài khoản ngân hàng.\n 
        Hãy thực hiện liên kết ngay để trải nghiệm\n đầy đủ các tính năng!`
            }}
          </div>

          <a
            class="me-2 mt-4"
            href="https://payment.salework.net/digital-banking"
            target="blank">
            <el-button
              type="primary"
              size="small">
              Liên kết ngay
            </el-button>
          </a>
        </div>
      </div>
      <div
        v-else
        style="min-height: 400px; max-height: 400px; overflow-y: auto">
        <div
          v-for="debt in debtListView"
          :key="debt.debtId"
          class="py-2">
          <div class="d-flex align-items-center justify-content-between my-1 px-12">
            <div
              class="d-flex align-items-center pointer"
              @click="copyToClipboard(debt.billRef, 'Đã copy vào bộ nhớ tạm')">
              <span class="me-1 fw-semibold">{{ debt.billRef }}</span>
              <IconV2 name="v2-copy" />
            </div>
            <div
              v-if="debt.status === 'RECONCILED'"
              class="text-white font-12 fw-semibold px-2 rounded-1"
              style="background-color: #218656">
              ĐÃ ĐỐI SOÁT
            </div>
            <div
              v-else-if="debt.status === 'COLLECTED'"
              class="text-white font-12 fw-semibold px-2 rounded-1"
              style="background-color: #218656">
              ĐÃ THANH TOÁN
            </div>
            <div
              v-else-if="debt.status === 'CANCELLED'"
              class="text-white font-12 fw-semibold px-2 rounded-1"
              style="background-color: #9497a5">
              ĐÃ HỦY
            </div>
            <div
              v-else
              class="text-white font-12 fw-semibold px-2 rounded-1"
              style="background-color: #cf4547">
              CHƯA THANH TOÁN
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between text-grey600 my-1 px-12">
            <span>TK thu: {{ debt.accountNo }}</span>
            <span>{{ moment(debt.updatedDate).format("DD/MM/YYYY HH:mm:ss") }}</span>
          </div>
          <div class="d-flex align-items-center justify-content-between my-1 px-12">
            <span class="fw-semibold text-blue600 font-14">{{ formatCurrency(debt.amount) }}</span>
            <span
              v-if="debt.status === 'NEW'"
              class="text-blue600 font-14 pointer"
              @click="getQrFromDebt(debt.id)">
              <ins class="me-1">Lấy mã QR</ins>
              <img src="/assets/images/qr_code_color.svg" />
            </span>
            <span
              v-else
              class="text-grey600">
              Người tạo: {{ debt.usernameInCharge }}
            </span>
          </div>
          <el-divider class="my-0" />
        </div>
        <div v-if="!debtListView.length" class="d-flex flex-column align-items-center" >
          <img src="/assets/images/empty-merchant.svg" />
          <div
            class="text-grey600 font-16 text-center"
            style="height: 150px; white-space: pre">
            {{
              `Chưa có lịch sử giao dịch`
            }}
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="dialogDebtQR"
      :visible="debtId ? true : false"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      append-to-body
      @close="debtId = null"
      width="415px">
      <div
        slot="title"
        class="mb-2 font-16 fw-700 text-center">
        Tạo mã thành công
      </div>
      <div>
        <div
          class="d-flex flex-column align-items-center justify-content-center rounded-2 mx-12 pt-3"
          style="border: 1px solid #eaecf2">
          <div
            class="d-flex align-items-center flex-grow-1 merchant-container"
            style="width: 365px; margin-bottom: -30px; z-index: 99">
            <img
              v-if="selectedMerchant?.bankCode == 'BIDV'"
              src="/assets/images/logo-BIDV.svg" />
            <div class="d-flex flex-column flex-grow-1 px-12">
              <span class="font-14 fw-700 text-blue500">{{ selectedMerchant?.accountNo }}</span>
              <span class="font-13 text-grey700">{{ selectedMerchant?.accountName }}</span>
            </div>
            <IconV2
              name="v2-arrow1_drop_down"
              size="20px" />
          </div>
          <div
            v-if="loading"
            style="height: 376px"
            v-loading="true"></div>
          <img
            v-else
            :src="'data:image/png;base64,' + imgBase64"
            alt="QR Code" />
        </div>

        <div class="d-flex justify-content-end px-12 py-12">
          <el-button
            type="info"
            @click="$emit('close')">
            Xong
          </el-button>
          <el-button
            type="primary"
            @click="sendImg">
            Gửi vào hội thoại
          </el-button>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import Vue from "vue";
import moment from "moment";
Vue.use(moment);

export default {
  props: ["conversation"],
  data() {
    return {
      loading: false,
      imgBase64: "",
      debtId: null,
      debt: {
        amount: "",
        billRef: "",
        payer: "",
        userInCharge: "",
        note: "",
      },
      selectedMerchant: null,
      merchantList: [],
      debtList: [],
      tab: "create",
    };
  },
  watch: {
    tab() {
      if (this.tab === "history") {
        this.getPaymentDebt();
      }
    },
  },
  computed: {
    debtListView() {
      return this.debtList;
    },
  },
  methods: {
    createNewDebt() {
      if (!this.debt.amount) {
        return this.alertError("Vui lòng nhập số tiền!");
      }
      this.loading = true;
      this.$http
        .post("/api/payment/createDebt", {
          conversationId: this.conversation.id,
          merchantId: this.selectedMerchant.id,
          amount: this.debt.amount || 0,
          billRef: this.debt.billRef,
          payer: this.debt.payer,
          billRefAutoGenerated: this.debt.billRef ? false : true,
          note: this.debt.note,
          status: "NEW",
          userInCharge: this.debt.userInCharge,
          stockOrderId: "",
        })
        .then((resp) => {
          this.debtId = resp.data.id;
          this.genQR(resp.data.id);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    genQR(id) {
      this.$http
        .get("/api/payment/genQR?id=" + id)
        .then((resp) => {
          this.imgBase64 = resp.data.vietQRImage;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getMerchantList() {
      return this.$http.get("/api/payment/getMerchantList").then((resp) => {
        this.merchantList = resp.data;
        this.selectedMerchant = this.merchantList[0];
      });
    },
    getPaymentDebt() {
      this.$http.get("/api/payment/getDebtHistory?conversationId=" + this.conversation.id).then(async (resp) => {
        const debtListRes = await this.$http.post("/api/payment/getDebtDetails", {
          ids: resp.data.map((debt) => debt.debtId),
        });
        this.debtList = debtListRes.data.reverse();
      });
    },
    DataURIToBlob(dataURI) {
      const splitDataURI = dataURI.split(",");
      const byteString = splitDataURI[0].indexOf("base64") >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
      const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

      return new Blob([ia], { type: mimeString });
    },
    sendImg() {
      const blob = this.DataURIToBlob("data:image/png;base64," + this.imgBase64);
      this.$emit("sendQR", blob, this.debtId);
    },
    getQrFromDebt(id) {
      this.debtId = id;
      this.genQR(id);
    },
  },
  mounted() {
    this.debt.payer = this.conversation.swName || this.conversation.toName;
    this.debt.userInCharge = this.app.user.swUsername;
    this.getMerchantList();
    this.selectedMerchant = this.merchantList[0];
  },
};
</script>

<style lang="scss">
.dialogManageDebt {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.dialogDebtQR {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.merchant-container {
  background-color: rgba(225, 237, 253, 0.32);
  border: 1px solid #e1edfd;
  border-radius: 4px;
  height: 52px;
  padding-left: 12px;
  padding-right: 12px;
}
</style>